var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.options.value.formId)?_c('new-page-gen',{attrs:{"options":_vm.options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }